import { useAutoneTranslation } from '@autone/translations';

import { Button } from '../../../../atoms';
import { useAdvancedFiltersInternalContext } from '../contexts/advanced-filters-internal.context';

export const AdvancedFiltersAddConditionButton = () => {
  const { common } = useAutoneTranslation();
  const { dispatch } = useAdvancedFiltersInternalContext();

  return (
    <Button
      id="add-condition-button"
      aria-label={common('advanced-filters.add-row')}
      size="sm"
      variant="outline"
      className="w-fit shadow-sm text-sm h-9 font-normal"
      onClick={() => dispatch({ type: 'ADD_CONDITION' })}
    >
      {common('advanced-filters.add-row')}
    </Button>
  );
};
